import React, { useContext } from 'react';
import type { PostLayoutSize } from './Sizes';

const PostLayoutSizeContext = React.createContext<PostLayoutSize>('mobile');
export const usePostLayoutSize = () => useContext(PostLayoutSizeContext);

const PostLayoutSizeProvider = ({
  children,
  postLayoutSize,
}: {
  children: React.ReactNode;
  postLayoutSize: PostLayoutSize;
}) => {
  return (
    <PostLayoutSizeContext.Provider value={postLayoutSize}>
      {children}
    </PostLayoutSizeContext.Provider>
  );
};

export default PostLayoutSizeProvider;
